<div class="container-fluid">
  <div class="container mt-3 mb-5 py-5 container-shadow">
    <div class="row">
      <div class="col">
        <h3>Tax Obligations</h3>
        <div class="my-3">
          <button type="button" (click)="makePayment()" [disabled]="makingPayment" class="btn btn-primary">Pay selected obligations</button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="card">
          <div class="card-header">Auto Pay Taxes</div>
          <div class="card-body">
            <table class="table table-striped table-sm">
              <thead class="thead-dark">
                <tr>
                  <th>
                    <div class="custom-control custom-checkbox mb-0" (click)="taxObligations.auto_tax_obligations_all_select = !taxObligations.auto_tax_obligations_all_select; allSelect('auto_tax_obligations')">
                      <input type="checkbox" class="custom-control-input" [checked]="taxObligations.auto_tax_obligations_all_select" [(ngModel)]="taxObligations.auto_tax_obligations_all_select" />
                      <label class="custom-control-label"></label>
                    </div>
                  </th>
                  <th>Tax</th>
                  <th>Outstanding</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let tax of taxObligations.auto_tax_obligations">
                  <td>
                    <div class="custom-control custom-checkbox mb-0" (click)="tax.selected = !tax.selected">
                      <input type="checkbox" class="custom-control-input" [checked]="tax.selected" [(ngModel)]="tax.selected" />
                      <label class="custom-control-label"></label>
                    </div>
                  </td>
                  <td>
                    <a [routerLink]="'/taxes/' + tax.id">{{ tax.name }}</a>
                    <div *ngIf="tax.tax_obligations && tax.tax_obligations.length > 0">
                      <table class="table table-sm">
                        <tbody>
                          <tr *ngFor="let taxObligation of tax.tax_obligations">
                            <td>
                              <div class="custom-control custom-checkbox mb-0" (click)="taxObligation.selected = !taxObligation.selected">
                                <input type="checkbox" class="custom-control-input" [checked]="taxObligation.selected" [(ngModel)]="taxObligation.selected" />
                                <label class="custom-control-label"></label>
                              </div>
                            </td>
                            <td>
                              {{ taxObligation.created_at_str }}
                            </td>
                            <td>
                              {{ taxObligation.amount | currency: 'USD':'symbol-narrow':'1.2-2' }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                  <td>
                    {{ tax.outstanding | currency: 'USD':'symbol-narrow':'1.2-2' }}
                  </td>
                </tr>
                <tr>
                  <td class="table-primary"></td>
                  <td class="text-right pr-3 table-primary">
                    <strong>Total:</strong>
                  </td>
                  <td class="table-primary">
                    <strong>{{ taxObligations.auto_tax_obligations_total | currency: 'USD':'symbol-narrow':'1.2-2' }}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="card">
          <div class="card-header">Other Taxes</div>
          <div class="card-body">
            <table class="table table-striped table-sm">
              <thead class="thead-dark">
                <tr>
                  <th>
                    <div class="custom-control custom-checkbox mb-0" (click)="taxObligations.other_tax_obligations_all_select = !taxObligations.other_tax_obligations_all_select; allSelect('other_tax_obligations')">
                      <input type="checkbox" class="custom-control-input" [checked]="taxObligations.other_tax_obligations_all_select" [(ngModel)]="taxObligations.other_tax_obligations_all_select" />
                      <label class="custom-control-label"></label>
                    </div>
                  </th>
                  <th>Tax</th>
                  <th>Outstanding</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let tax of taxObligations.other_tax_obligations">
                  <td>
                    <div class="custom-control custom-checkbox mb-0" (click)="tax.selected = !tax.selected">
                      <input type="checkbox" class="custom-control-input" [checked]="tax.selected" [(ngModel)]="tax.selected" />
                      <label class="custom-control-label"></label>
                    </div>
                  </td>
                  <td>
                    <a [routerLink]="'/taxes/' + tax.id">{{ tax.name }}</a>
                    <div *ngIf="tax.tax_obligations && tax.tax_obligations.length > 0">
                      <table class="table table-sm">
                        <tbody>
                          <tr *ngFor="let taxObligation of tax.tax_obligations">
                            <td>
                              <div class="custom-control custom-checkbox mb-0" (click)="taxObligation.selected = !taxObligation.selected">
                                <input type="checkbox" class="custom-control-input" [checked]="taxObligation.selected" [(ngModel)]="taxObligation.selected" />
                                <label class="custom-control-label"></label>
                              </div>
                            </td>
                            <td>
                              {{ taxObligation.created_at_str }}
                            </td>
                            <td>
                              {{ taxObligation.amount | currency: 'USD':'symbol-narrow':'1.2-2' }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                  <td>
                    {{ tax.outstanding | currency: 'USD':'symbol-narrow':'1.2-2' }}
                  </td>
                </tr>
                <tr>
                  <td class="table-primary"></td>
                  <td class="text-right pr-3 table-primary">
                    <strong>Total:</strong>
                  </td>
                  <td class="table-primary">
                    <strong>{{ taxObligations.other_tax_obligations_total | currency: 'USD':'symbol-narrow':'1.2-2' }}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #paymentModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Pay Tax Obligations</h4>
    <button type="button" class="close" [disabled]="creatingPayment" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <span class="text-muted">Based on the obligations selected, these are the disbursments grouped by contact that will be created. You may enter the actual amounts to pay in the boxes below.</span>
    <table *ngFor="let paymentCheck of paymentChecks" class="table table-sm">
      <thead>
        <tr class="thead-dark">
          <th colspan="2">
            {{ paymentCheck.name }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let tax of paymentCheck.taxes">
          <td>
            {{ tax.short_name }}
          </td>
          <td style="width: 175px">
            <input style="width: 175px" type="number" class="text-right form-control form-control-sm" [(ngModel)]="tax.amount" (change)="calculatePaymentChecksTaxTotal()" />
          </td>
        </tr>
        <tr>
          <td class="text-right table-primary">
            <strong>Total</strong>
          </td>
          <td class="text-right pr-3 table-primary" style="width: 175px">
            {{ paymentCheck.taxTotal | currency: 'USD':'symbol-narrow':'1.2-2' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer text-center justify-content-center">
    <div class="text-center">
      <button [disabled]="creatingPayment" (click)="createPayment()" type="button" class="btn btn-primary">
        {{ creatingPayment ? 'Paying' : 'Pay' }}
        <span *ngIf="creatingPayment">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
      </button>
      &nbsp;
      <button [disabled]="creatingPayment" (click)="d('close')" type="button" class="btn btn-outline-secondary">Cancel</button>
    </div>
  </div>
</ng-template>
